"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink");

var InputSearch =
/** @class */
function (_super) {
  __extends(InputSearch, _super);

  function InputSearch(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (event) {
      var value = event.target.value;

      _this.setState({
        value: value
      });

      _this.props.onChange(value, _this.props.name, event);
    };

    _this.onClear = function (event) {
      _this.setState({
        value: ""
      });

      _this.props.onChange("", _this.props.name, event);
    };

    _this.doNotSubmit = function (event) {
      event.preventDefault();
    };

    _this.state = {
      value: ""
    };
    return _this;
  }

  InputSearch.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        disabled = _a.disabled,
        placeholder = _a.placeholder,
        name = _a.name;
    var value = this.state.value; // TODO Form Component

    return React.createElement("form", {
      onSubmit: this.doNotSubmit,
      role: "search"
    }, React.createElement("label", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "input-search", className])
    }, React.createElement(Icon_1.Icon, {
      name: Icon_1.Icon.Names.interaction___search,
      className: CSSPrefix_1.lsgPre + "input-search-icon"
    }), React.createElement("input", {
      type: "search",
      disabled: disabled,
      autoComplete: "off",
      placeholder: placeholder,
      onChange: this.onChange,
      className: CSSPrefix_1.lsgPre + "input-search-input",
      value: value,
      "aria-label": placeholder,
      name: name
    }), value && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "input-search-clear",
      iconName: Icon_1.Icon.Names.interaction___close,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.onClear,
      htmlAttrs: {
        tabIndex: -1,
        role: "none"
      }
    }, utils_1.Localization.texts.lsg.component.InputSearch.clear)));
  };

  InputSearch.defaultProps = {
    placeholder: utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.InputSearch.placeholder,
    name: "",
    onChange: function onChange() {
      /* empty */
    }
  };
  return InputSearch;
}(React.Component);

exports.InputSearch = InputSearch;